export default {
  lang: {
    confirm: {
      title: '削除しますか? 削除後は復元できません',
      okText: '削除',
      cancelText: 'キャンセル',
    },
  },
};
